module.exports = __webpack_public_path__ + "img/empty_message.75e68e23.png";